// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".export[data-v-cf15c2a8]{padding-right:20px;font-size:15px}.export p a[data-v-cf15c2a8]{color:#3079f4}.export h3[data-v-cf15c2a8]{font-size:20px;font-weight:500;border-top:1px solid #ebebeb;padding-top:15px}.export-title[data-v-cf15c2a8]{font-size:20px;font-weight:500;margin-bottom:20px}.export-json-example[data-v-cf15c2a8]{display:block;border-radius:2px;margin-top:5px;padding:10px;background-color:#e1e1e1;font-size:12px;font-family:monotype, monotype;overflow:auto}\n", ""]);
// Exports
module.exports = exports;
